import type { FC } from 'react'

import { config } from '@skytech/config'
import { TestErrorPage } from '@skytech/monitoring'
import { Route, Routes } from 'react-router-dom'

import CreditRequestNewQuotePage from '@/components/credit-request/CreditRequestNewQuotePage'
import CreditRequestPage from '@/components/credit-request/CreditRequestPage'
import Customer from '@/components/customers/Customer'
import CustomerList from '@/components/customers/CustomerList'
import NewCustomer from '@/components/customers/NewCustomer'
import DeviceOrderPage from '@/components/device-orders/device-order-page/DeviceOrderPage'
import DeviceOrders from '@/components/device-orders/DeviceOrders'
import DevicePolicies from '@/components/device-policies/DevicePolicies'
import AllSystemMessagesPage from '@/components/header/AllSystemMessagesPage'
import { Home } from '@/components/home/Home'
import InjuryReportListPage from '@/components/injury-reports'
import { InjuryReportPage } from '@/components/injury-reports/InjuryReportPage'
import Orders from '@/components/orders/Orders'
import { ProductsPage } from '@/components/orders/products/ProductsPage'
import { SalesSupport } from '@/components/sales-support'
import { DemoCustomer } from '@/components/sales-support/DemoCustomer'
import EcomOrderPage from '@/components/shop/orders/order/EcomOrderPage'
import ShopOrdersPage from '@/components/shop/orders/ShopOrdersPage'
import ShopQuoteListPage from '@/components/shop/ShopQuoteListPage'
import ShopQuotePage from '@/components/shop/ShopQuotePage'
import SubscriptionOrderPage from '@/components/subscription-orders/subscription-order-page/SubscriptionOrderPage'
import { SubscriptionOrders } from '@/components/subscription-orders/SubscriptionOrders'
import TestComponent from '@/components/test/TestComponent'
import WhitelabelPage from '@/components/test/WhitelabelPage'
import useBetaAccess from '@/hooks/beta-access'
import { TradeInOrders } from '@/modules/trade-in/orders'
import { appRoutes } from '@/util/misc'

import './pages.scss'

export const Pages: FC = () => {
  const { hasSalesSupport, hasTradeInAccess } = useBetaAccess()
  const isDevelopmentMode = config.ENVIRONMENT === 'dev'

  return (
    <div className="content w-full">
      <Routes>
        {/* For testing sentry error reports */}
        {process.env.VERCEL_ENV !== 'production' && (
          <Route path="/monitoring" element={<TestErrorPage />} />
        )}

        <Route path={appRoutes.newCustomer} element={<NewCustomer />} />
        <Route path={`${appRoutes.customer}/*`} element={<Customer />} />
        <Route path={appRoutes.customers} element={<CustomerList />} />
        <Route path={appRoutes.orders} element={<Orders />} />
        <Route path={appRoutes.devicePolicyPrices} element={<DevicePolicies />} />
        <Route path={appRoutes.subscriptionOrders} element={<SubscriptionOrders />} />
        <Route path={appRoutes.subscriptionOrder} element={<SubscriptionOrderPage />} />
        <Route path={appRoutes.deviceOrders} element={<DeviceOrders />} />
        <Route path={appRoutes.deviceOrder} element={<DeviceOrderPage />} />
        <Route path={appRoutes.shopQuoteList} element={<ShopQuoteListPage />} />
        <Route path={appRoutes.shopOrder} element={<EcomOrderPage />} />
        <Route path={appRoutes.shopOrders} element={<ShopOrdersPage />} />
        <Route path={appRoutes.ordersShop} element={<ShopOrdersPage />} />
        <Route path={appRoutes.shopQuote} element={<ShopQuotePage />} />

        {/* // TODO: enable for production */}
        {isDevelopmentMode && <Route path={appRoutes.ordersProducts} element={<ProductsPage />} />}

        <Route path={appRoutes.creditRequest} element={<CreditRequestPage />} />
        <Route path={appRoutes.creditRequestNewQuote} element={<CreditRequestNewQuotePage />} />
        <Route path={appRoutes.creditCheck} element={<ShopQuoteListPage />} />
        <Route path={appRoutes.creditCheckQuote} element={<ShopQuotePage />} />
        <Route path={appRoutes.test} element={<TestComponent />} />
        <Route path={appRoutes.whiteLabel} element={<WhitelabelPage />} />
        <Route path={appRoutes.injuryReports} element={<InjuryReportListPage />} />
        <Route path={appRoutes.injuryReport} element={<InjuryReportPage />} />
        <Route path={appRoutes.systemMessages} element={<AllSystemMessagesPage />} />
        {hasSalesSupport && <Route path={appRoutes.salesSupport} element={<SalesSupport />} />}
        {hasSalesSupport && (
          <Route path={`${appRoutes.salesSupport}/:id`} element={<DemoCustomer />} />
        )}
        {hasTradeInAccess && <Route path={appRoutes.tradeInOrders} element={<TradeInOrders />} />}
        <Route path="*" element={<Home />} />
      </Routes>
    </div>
  )
}

export default Pages
